import { helpers } from '@vuelidate/validators';

import config from '../config';

type PasswordPolicyChecker = (password: string) => boolean;

type PasswordPolicies = {
  [key: string]: PasswordPolicyChecker;
};

export const passwordPolicies: PasswordPolicies = Object.fromEntries(
  Object.entries(config.passwordPolicies as Record<string, string>).map(([key, reg]) => [
    key,
    // nosemgrep
    helpers.regex(new RegExp(reg)),
  ])
);
